import { OrganizationType } from './organization.type';

export type Weekday =
  | 'sunday'
  | 'monday'
  | 'tuesday'
  | 'wednesday'
  | 'thursday'
  | 'friday'
  | 'saturday';

export const WEEKDAY_LABELS: Record<Weekday, string> = {
  sunday: 'Sunday',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
};

export const WEEKDAYS_ORDER: Weekday[] = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

export interface OrganizationOnboardingFormState {
  name: string;
  organization_type: OrganizationType | '';
  city: string;
  contact_email: string;
  phone: string;

  organization_address: string;
  national_address_short: string;
  national_address_document: File | null;
  cr_number: string;
  cr_document: File | null;
  vat_number: string;
  vat_document: File | null;
  iban_certificate_document: File | null;
  iban: string;
  bank_name: string;
  bank_account_number: string;
  mwan_certificate_document: File | null;
  mwan_license_number: string;

  waste_types: string[];
  /** Names of the selected waste types, so a reviewer sees names rather than ids. */
  waste_type_names: string[];
  other_waste_type: string;
  google_maps_url: string;
  notes: string;
  /** null = user has not chosen yet (invalid until step submit) */
  is_24_7: boolean | null;
  operation_days: Weekday[];
  operation_start: Date | null;
  operation_end: Date | null;

  policies_acknowledged: boolean;
}

export function createEmptyOrganizationOnboardingForm(): OrganizationOnboardingFormState {
  return {
    name: '',
    organization_type: '',
    city: '',
    contact_email: '',
    phone: '',

    organization_address: '',
    national_address_short: '',
    national_address_document: null,
    cr_number: '',
    cr_document: null,
    vat_number: '',
    vat_document: null,
    iban_certificate_document: null,
    iban: '',
    bank_name: '',
    bank_account_number: '',
    mwan_certificate_document: null,
    mwan_license_number: '',

    waste_types: [],
    waste_type_names: [],
    other_waste_type: '',
    google_maps_url: '',
    notes: '',
    is_24_7: null,
    operation_days: [],
    operation_start: null,
    operation_end: null,

    policies_acknowledged: false,
  };
}

export function requiresMwanFields(organizationType: OrganizationType | ''): boolean {
  return organizationType === OrganizationType.RECYCLER || organizationType === OrganizationType.TRUCK;
}
